export default "__VITE_ASSET__C9DcWAgb__"